import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Axios from 'axios';
import * as Yup from 'yup';
import {
  CRUDLayout,
  Alert,
  THead,
  TBody,
  Tr,
  ThFixed,
  TdFixed,
  Th,
  Td,
  ActionButton,
  Input,
  BackButton,
  DataStatus,
  TextArea,
} from '../../../../components';
import { PengembalianBarangApi } from '../../../../api';
import { useHistory } from 'react-router-dom';
import { DateConvert } from '../../../../utilities';
import { Card, Col, Row } from 'react-bootstrap';
import { Formik } from 'formik';

const TambahPengembalianBarang = ({ setNavbarTitle }) => {
  // indikator pemanggilan data sedang dimuat di server (loading)
  const [isLoading, setIsLoading] = useState(true);

  const history = useHistory();

  // data
  const [data, setData] = useState([]);
  // menampung data yang akan dihapus

  // menampilkan alert
  const [showAlert, setShowAlert] = useState(false);
  // configurasi alert
  const [alertConfig, setAlertConfig] = useState({
    variant: 'primary',
    text: '',
    status: false,
  });

  const { id } = useParams();

  // request data dari server
  const getData = () => {
    setIsLoading(true);
    Axios.all([PengembalianBarangApi.getForm(id)])
      .then(
        Axios.spread((res) => {
          setData(res.data);
        })
      )
      .catch(() => {
        setAlertConfig({
          variant: 'danger',
          text: 'Data gagal dimuat',
        });
        setShowAlert(true);
      })
      .finally(() => setIsLoading(false));
  };

  useEffect(() => {
    // set Judul di Navbar
    setNavbarTitle('Pengembalian Barang');

    // jalankan function request data ke server
    getData();
    return () => {
      setIsLoading(false);
    };
  }, [setNavbarTitle]);

  const TambahData = () => {
    const [isNomorLoading, setIsNomorLoading] = useState(false);
    const [kode, setKode] = useState('');

    const getNomor = (value, setFieldValue) => {
      setIsNomorLoading(true);

      PengembalianBarangApi.getKode(value)
        .then(({ data }) => {
          setKode(data.data);
          setFieldValue('no_delivery_order', data.data);
        })
        .catch((err) => alert('Gagal mengambil nomor delivery order'))
        .finally(() => setIsNomorLoading(false));
    };

    const formInitialValues = {
      id_delivery_order: id,
      tgl_pengembalian_barang: '',
    };

    const formValidationSchema = Yup.object().shape({
      tgl_pengembalian_barang: Yup.string().required(
        'Masukan tanggal pengembalian barang '
      ),
      // no_pengembalian_barang: Yup.string().required("Masukan no pengembalian barang "),
    });

    const formSubmitHandler = (values) => {
      PengembalianBarangApi.create(values)
        .then(() => {
          history.push('/inventory/transaksi/pengembalian-barang/', {
            variant: 'primary',
            text: 'Data berhasil di tambah',
            status: true,
          });
        })
        .catch((err) => {
          history.push('/inventory/transaksi/pengembalian-barang/', {
            variant: 'danger',
            text: `Tambah data gagal! (${err.response.data.message})`,
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    };

    const ShowData = ({ title, text }) => (
      <div className="d-flex flex-row">
        <div className="text-secondary mb-2 mr-3" style={{ width: 170 }}>
          <span style={{ textTransform: 'capitalize' }}>{title}</span>
        </div>
        <span>:</span>
        <div
          className="text-dark"
          style={{
            fontWeight: 200,
            paddingLeft: 40,
          }}
        >
          {text ? text : '-'}
        </div>
      </div>
    );

    return (
      <>
        <Row>
          <Col lg="6">
            <ShowData
              title="Tgl. pembatalan faktur"
              text={
                DateConvert(new Date(data?.data?.tgl_pembatalan_faktur)).detail
              }
            />
          </Col>
          <Col lg="6">
            <ShowData
              title="No. pembatalan faktur"
              text={data?.data?.no_pembatalan_faktur}
            />
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <ShowData
              title="Tgl. faktur penjualan"
              text={DateConvert(new Date(data?.data?.tgl_faktur)).detail}
            />
          </Col>
          <Col lg="6">
            <ShowData
              title="No. faktur penjualan"
              text={data?.data?.no_faktur}
            />
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <ShowData
              title="Tgl. delivery order"
              text={
                DateConvert(new Date(data?.data?.tgl_delivery_order)).detail
              }
            />
          </Col>
          <Col lg="6">
            <ShowData
              title="No. delivery order"
              text={data?.data?.no_delivery_order}
            />
          </Col>
        </Row>
        <Row>
          <Col lg="6">
            <ShowData title="Customer" text={data?.data?.nama_customer} />
          </Col>
          <Col lg="6">
            <ShowData title="Sales" text={data?.data?.nama_sales} />
          </Col>
        </Row>
        <hr />
        <Formik
          initialValues={formInitialValues}
          validationSchema={formValidationSchema}
          onSubmit={formSubmitHandler}
        >
          {({
            values,
            errors,
            touched,
            isSubmitting,
            setFieldValue,
            handleSubmit,
          }) => (
            <form onSubmit={handleSubmit}>
              <Row>
                <Col lg="6">
                  <Input
                    label="Tanggal pengembalian barang"
                    type="date"
                    name="tgl_pengembalian_barang"
                    onChange={(e) => {
                      const value = e.target.value;

                      setFieldValue('tgl_pengembalian_barang', value);
                      getNomor(value, setFieldValue);
                    }}
                    error={
                      errors.tgl_pengembalian_barang &&
                      touched.tgl_pengembalian_barang &&
                      true
                    }
                    errorText={errors.tgl_pengembalian_barang}
                  />
                </Col>
                <Col lg="6">
                  <Input
                    label="No. pengembalian barang"
                    type="text"
                    name="no_pengembalian_barang"
                    placeholder={
                      isNomorLoading
                        ? 'Memuat . . . '
                        : values.tgl_pengembalian_barang
                        ? kode
                        : 'Pilih tanggal terlebih dahulu'
                    }
                    readOnly={true}
                    onChange={(e) => {
                      setFieldValue('no_pengembalian_barang', e.target.value);
                    }}
                    error={
                      errors.no_pengembalian_barang &&
                      touched.no_pengembalian_barang &&
                      true
                    }
                    errorText={errors.no_pengembalian_barang}
                  />
                </Col>
              </Row>
              <div className="mb-4"></div>
              <CRUDLayout.Table>
                <THead>
                  <Tr className="text-center">
                    <ThFixed>No</ThFixed>
                    <Th>Kode barang</Th>
                    <Th>Nama barang</Th>
                    <Th>Gudang</Th>
                    <Th>Qty DO</Th>
                    <Th>Satuan</Th>
                    <Th>Pengembalian</Th>
                  </Tr>
                </THead>
                <TBody>
                  {data?.data?.detail.map((val, index) => (
                    <Tr key={index}>
                      <TdFixed>{index + 1}</TdFixed>
                      <TdFixed>{val.kode_barang}</TdFixed>
                      <Td>{val.nama_barang}</Td>
                      <Td>{val.nama_gudang}</Td>
                      <Td>{val.qty}</Td>
                      <Td>{val.nama_satuan}</Td>
                      <Td>
                        <Input
                          type="number"
                          name={
                            'detail[index][qty_pengembalian, id_delivery_order]'
                          }
                          onChange={(e) => {
                            setFieldValue(
                              `detail[${index}][qty_pengembalian]`,
                              e.target.value
                            );
                            setFieldValue(
                              `detail[${index}][id_delivery_order_detail]`,
                              val.id_delivery_order_detail
                            );
                          }}
                          error={
                            errors.qty_pengembalian &&
                            touched.qty_pengembalian &&
                            true
                          }
                          errorText={errors.qty_pengembalian}
                        />
                      </Td>
                    </Tr>
                  ))}
                </TBody>
              </CRUDLayout.Table>
              <div className="d-flex justify-content-end">
                <ActionButton
                  type="submit"
                  variant="primary"
                  text="Simpan"
                  className="mt-2 px-4"
                  loading={isSubmitting}
                />
              </div>
            </form>
          )}
        </Formik>
      </>
    );
  };

  return (
    <Card>
      <Card.Header className="d-flex flex-row justify-content-between">
        <span>Tambah Penerimaan Retur</span>

        <BackButton
          onClick={() => {
            history.goBack();
          }}
        />
      </Card.Header>
      <Card.Body>
        <Alert
          show={showAlert}
          showCloseButton={true}
          variant={alertConfig.variant}
          text={alertConfig.text}
          onClose={() => setShowAlert(false)}
        />
        {isLoading === true ? (
          <DataStatus loading={true} text="Memuat data..." />
        ) : data.status === true ? (
          <TambahData />
        ) : (
          <DataStatus text="Tidak ada data" />
        )}
      </Card.Body>
    </Card>
  );
};

export default TambahPengembalianBarang;
